"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DRAWDOWN_PERCENT = void 0;
exports.getLegacyMaxRemainingDrawdownAmount = getLegacyMaxRemainingDrawdownAmount;
exports.getMaxRemainingDrawdownAmount = getMaxRemainingDrawdownAmount;
const case_payment_status_helpers_js_1 = require("./case-payment-status.helpers.js");
const case_workflow_helpers_js_1 = require("./case-workflow.helpers.js");
exports.MAX_DRAWDOWN_PERCENT = 80;
/** Legacy cap: 80% of (milestone budget − sub-milestones) minus drawdown already taken. */
function getLegacyMaxRemainingDrawdownAmount(milestone) {
    const totalSub = milestone.subMilestones?.reduce((sum, sub) => sum + (Number(sub.budgetAmount) || 0), 0) ?? 0;
    const budgetBase = Math.max(0, (milestone.budgetAmount ?? 0) - totalSub);
    const cap = (budgetBase * exports.MAX_DRAWDOWN_PERCENT) / 100 - (milestone.drawdownAmount ?? 0);
    return Math.max(0, Math.round(cap * 100) / 100);
}
/**
 * Max additional drawdown allowed.
 * Legacy: 80% of (milestone budget − sub-milestones) minus drawdown already taken.
 * CASE: 80% of amount currently held in escrow (after pay-in partial release and prior drawdowns).
 */
function getMaxRemainingDrawdownAmount(milestone, options) {
    const invoice = milestone.invoice ??
        (milestone.projectInvoiceId && options?.invoices?.length
            ? options.invoices.find((inv) => inv.id === milestone.projectInvoiceId)
            : null);
    const isCase = (0, case_workflow_helpers_js_1.resolveIsCaseWorkflow)({ invoice }) || options?.isCaseWorkflow === true;
    if (!isCase) {
        return getLegacyMaxRemainingDrawdownAmount(milestone);
    }
    const { held } = (0, case_payment_status_helpers_js_1.getCaseMilestoneEscrowAmounts)(milestone, options?.invoices ?? (invoice ? [invoice] : null));
    const cap = (held * exports.MAX_DRAWDOWN_PERCENT) / 100;
    return Math.max(0, Math.round(cap * 100) / 100);
}
